var React = require('react');

function Discoveryandresearchicon01Inline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z","stroke":"#FF6A3C","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M34.7422 13L29.7422 29.5L13.7422 35L18.7422 18.5L34.7422 13Z","stroke":"#FF6A3C","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M34.7422 13L29.7422 29L24.5208 23.6667L18.7422 18.3333L34.7422 13Z","fill":"#FF6A3C","stroke":"#FF6A3C","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Discoveryandresearchicon01Inline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Discoveryandresearchicon01Inline;

Discoveryandresearchicon01Inline.default = Discoveryandresearchicon01Inline;
